<template>
  <div class="align-center flex-row gap-3">
    <OwnProgressSpinner size="24" />
    <OwnType :text="message" variant="title-regular" />
  </div>
</template>

<script lang="ts" setup>
import { OwnProgressSpinner } from '@/ui/OwnProgressSpinner'
import { OwnType } from '@/ui/OwnType'

defineProps<{
  message: string
}>()
</script>
